const isAdWithoutInventory = (ad) => ad.estoque === 0

const isNotNull = (ad) => Boolean(ad)

export function getSortedAdsWithQuoteSimulationData(
  ads,
  quoteSimulationResponses
) {
  const adsWithoutInventory = ads.filter(isAdWithoutInventory)
  const adsWithInventory = ads.filter((ad) => !adsWithoutInventory.includes(ad))

  const findAdById = (adId, ads) => ads.find((ad) => ad.id === adId)

  const mapQuoteSimulationResponseToAd = (quoteSimulationResponse) => {
    const ad = findAdById(quoteSimulationResponse.id_anuncio, adsWithInventory)
    return ad
      ? {
          ...ad,
          frete: quoteSimulationResponse?.erro ? null : quoteSimulationResponse,
        }
      : null
  }

  const filterAds = (quoteSimulationResponses, adsWithInventory) => {
    const adsWithQuotes = quoteSimulationResponses
      .map(mapQuoteSimulationResponseToAd)
      .filter(isNotNull)

    const swapElements = (array, indexToBeReplaced, indexToReplace) => {
      array[indexToBeReplaced] = array.splice(
        indexToReplace,
        1,
        array[indexToBeReplaced]
      )[0]
    }

    const indexOnlyPickUp = adsWithQuotes.findIndex(
      (ad) =>
        ad.frete?.opcoes?.length === 1 && !!ad.frete?.lojas_retirada?.length
    )

    if (adsWithQuotes.length > 1 && indexOnlyPickUp === 0)
      swapElements(adsWithQuotes, 0, 1)

    return adsWithQuotes.length > 0 ? adsWithQuotes : adsWithInventory
  }

  const sortedAdsWithInventory =
    quoteSimulationResponses && quoteSimulationResponses.length > 0
      ? filterAds(quoteSimulationResponses, adsWithInventory)
      : adsWithInventory

  return sortedAdsWithInventory.concat(adsWithoutInventory)
}
